const transitionDurationMs = 375;
const transition = "_uxst1rrhgy6";
const wrapper = "_uxsw1bb7ifw";

export { transition, transitionDurationMs, wrapper };
import "./variant.embed.style.linaria.module.css";
//# sourceMappingURL=variant.embed.style.js.map
